import styled from 'styled-components'
import { themeObject, textModels } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: self-start;
	padding: 24px;
	box-sizing: border-box;
	box-shadow: 0 0 0 1px ${themeObject.colors.grey[200]};
	border-radius: 16px;
`
export const Title = styled.p`
	${textModels('notAdaptive', 'h2')}
	color: ${themeObject.colors.grey[800]};
	margin-bottom: 8px;
`
export const SubTitle = styled.p`
	${textModels('notAdaptive', 'm', '400')}
	color: ${themeObject.colors.grey[600]};
	flex-grow: 1;
`
export const Free = styled.p`
	${textModels('notAdaptive', 'm', '400')}
	color: ${themeObject.colors.brand[500]};
	background: ${themeObject.colors.brand[50]};
	padding: 8px;
	margin-top: 32px;
	border-radius: 8px;
`
